import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { get_settings } from "../../redux/actions/adminActions";
import { motion } from "framer-motion";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { animationValues, transitionValues } from "../../utils/pageTransitions";
import SiteDetails from "./settings/siteDetails";
import Operations from "./settings/operations";
import Fees from "./settings/fees";
import Currency from "./settings/currency";
import Account from "./settings/account";
import Help from "./settings/help";
import Spinner from "../reusables/spinner";


function Settings({ getSettings, accessToken }) {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getSettings(accessToken, () => setLoading(false));
  }, [accessToken]);

  return (
    <motion.div
      initial="out"
      animate="in"
      exit="out"
      variants={animationValues}
      transition={transitionValues}
    >
      <div className="container-fluid suppliers">
        <div className="">
          <h2 className="sectionText--big textIsBold">Settings</h2>
        </div>

        {!loading ? (
          <Tabs className="pt-3">
            <TabList className="alignOnly sectionText p-0">
              <Tab className="tabHead">Site Details</Tab>
              <Tab className="tabHead">Operations</Tab>
              <Tab className="tabHead">Fees</Tab>
              <Tab className="tabHead">Currency</Tab>
              {/* <Tab className="tabHead">Account Number</Tab> */}
              <Tab className="tabHead">Help</Tab>
            </TabList>

            <TabPanel>
              <SiteDetails />
            </TabPanel>
            <TabPanel>
              <Operations />
            </TabPanel>
            <TabPanel>
              <Fees />
            </TabPanel>
            <TabPanel>
              <Currency />
            </TabPanel>
            {/* <TabPanel>
              <Account />
            </TabPanel> */}
            <TabPanel>
              <Help />
            </TabPanel>
          </Tabs>
        ) : (
          <Spinner big />
        )}
      </div>
    </motion.div>
  );
}

const mapStateToProps = (state) => ({
  accessToken: state.admin.token,
});

const mapDispatchToProps = (dispatch) => ({
  getSettings: (token, success) => dispatch(get_settings(token, success)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Settings);
